export const Constant = {
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
    VALID_NUMBER_REGEX: /^(-?[1-9][0-9]*|0)$/,
    VALID_PHONE_NUMBER_REGEX: /^\d+$/,
    FACEBOOK_TOKEN_ERROR: "Unable to get facebook access token",
    GOOGLE_TOKEN_ERROR: "Unable to get google access token",
    EMAIL_REQUIRED: "Email is required",
    PHONE_REQUIRED: "Phone Number is required",
    EMAIL_INVALID: "Email is invalid",
    PHONE_INVALID: "Phone Number is invalid",
    PASSWORD_REQUIRED: "Password is required",
    SERVER_ERROR: "Unable to connect to the server!",
    CAMPAIGN_TITLE_REGEX: /^[a-zA-Z0-9\s-]+$/,
    CAMPAIGN_TITLE_REQUIRED: "Campaign title is required",
    CAMPAIGN_TITLE_MAX_LENGTH_ERROR: "Campaign title must be less than 50 characters",
    CAMPAIGN_NOT_FOUND_ERROR: "The campaign is not found",
    CAMPAIGN_ARCHIVED: "The campaign has been archived",
    PUBLISH_CAMPAIGN: "1",
    UNPUBLISH_CAMPAIGN: "0",
    PUBLISH_REPORT: "1",
    UNPUBLISH_REPORT: "0",
    ACTIVATE_USER: "1",
    DEACTIVATE_USER: "0",
    SIGNUP_SUCCESS: "A verification email has been sent to your email address. Please do check and verify your email.",
    EMAIL_SENT_SUCCESSFUL: "The email has been sent to donor successfully",
    TODAY: "Today",
    LAST_WEEK: "Last Week",
    LAST_MONTH: "Last Month",
    LAST_YEAR: "Last Year",
    ALL: "All",
    ONE_TIME: "One-time",
    RECURRING: "Recurring",
    MONTHLY: "Monthly",
    YEARLY: "Yearly",
    DAILY : "Daily",
    CAMPAIGN_GOAL_AMOUNT_LIMIT: 1000000000,
    PATIENT_GOAL_AMOUNT_LIMIT: 1000000000,
    PATIENT_AGE_LIMIT: 1000,
    DESERVING_ITEM_GOAL_AMOUNT_LIMIT: 1000000000,
    STANDARD_PRINTING_PAGE_HEIGHT_IN_PIXEL: 981,
    INVALID_FILE_TYPE: "Please select only image",
    FILE_SIZE_EXCEEDS_LIMIT: "File must be less than 1MB"
};
